@if (data) {
    @if (errorMessage) {
        <kui-alert-panel [message]="errorMessage"></kui-alert-panel>
    } @else {
        <div class="stat stat--{{ size }}">
            <div class="stat__value">
                @if (data.targetValue && data.targetValue !== 0) {
                    <svg viewBox="0 0 100 12" class="stat__value-text">
                        <text x="80%" y="10" [attr.fill]="data.color">
                            {{ data.targetValue }}
                        </text>
                    </svg>
                }
                <svg [attr.viewBox]="data.targetValue && data.targetValue !== 0 ? '0 0 90 12' : '0 0 56 12'" class="stat__value-text">
                    <text x="50%" y="10">{{ stat }}</text>
                </svg>
                @if (data.data === "last" && trend?.visible) {
                    <div class="stat__trend">
                        <kui-icon [name]="trend?.icon" [color]="trend?.color" [size]="size === 'large' ? 'md' : 'sm'"></kui-icon>
                        <span class="ml-1">{{ trend?.value }}</span>
                    </div>
                }
            </div>
        </div>
        @if (data.sparkline && dataset) {
            <key-graph
                [datasets]="[dataset]"
                [xAxis]="{ hidden: true }"
                [yAxes]="{ left: sparklineYAxis }"
                [averages]="[sparklineAverage]"
                tooltipMode="none"
                [labels]="data.labels"
            ></key-graph>
        }
    }
}
